var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},_vm._l((_setup.props.options),function(item){return _c('a-checkable-tag',{key:item.key,attrs:{"checked":_vm.value==item.key},on:{"change":function($event){return _setup.handleChange(item.key)}}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }